// @flow
import { get } from "lodash";
import mediatorChannels from "@tvg/mediator";
import pushToDataLayer from "../gtmUtils";

type GTMEducationArticleSelected = {
  type: "EDUCATIONAL_ARTICLE_SELECTED",
  payload: {
    articleName: string,
    sectionTitle: string,
    eventLabel: string
  }
};

type GTMEducationArticleViewed = {
  type: "EDUCATIONAL_ARTICLE_VIEWED",
  payload: {
    articleName: string,
    sectionTitle: string,
    eventLabel: string
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "EDUCATION_PILL_CLICKED",
    (data: { payload: { eventLabel: string } }) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "Pill Selected",
        gaEventLabel: get(data, "payload.eventLabel", ""),
        module: "Horse racing 101"
      });
    }
  );

  mediatorChannels.base.subscribe(
    "EDUCATION_TUTORIAL_CAROUSEL_SELECTED",
    (data: { payload: { tutorialName: string } }) => {
      pushToDataLayer({
        event: "education",
        gaEventCategory: "Education",
        gaEventAction: "Tutorial Selected",
        gaEventLabel: get(data, "payload.tutorialName", ""), // e.g "Live Streaming"
        module: "Tutorials",
        educationCategory: "walkthrough",
        paginationNumber: undefined,
        totalPages: undefined,
        articleName: get(data, "payload.tutorialName", "")
      });
    }
  );

  mediatorChannels.base.subscribe(
    "EDUCATIONAL_ARTICLE_SELECTED",
    (data: GTMEducationArticleSelected) => {
      pushToDataLayer({
        event: "education",
        gaEventCategory: "Education",
        gaEventAction: "Education Article Selected",
        gaEventLabel: get(data, "payload.eventLabel", ""),
        module: get(data, "payload.sectionTitle", ""),
        educationCategory: get(data, "payload.sectionTitle", ""),
        paginationNumber: undefined,
        totalPages: undefined,
        articleName: get(data, "payload.articleName", "")
      });
    }
  );

  mediatorChannels.base.subscribe(
    "EDUCATIONAL_ARTICLE_VIEWED",
    (data: GTMEducationArticleViewed) => {
      pushToDataLayer({
        event: "education",
        gaEventCategory: "Education",
        gaEventAction: "Education Article Viewed",
        gaEventLabel: get(data, "payload.eventLabel", ""),
        module: get(data, "payload.sectionTitle", ""),
        educationCategory: get(data, "payload.sectionTitle", ""),
        paginationNumber: undefined,
        totalPages: undefined,
        articleName: get(data, "payload.articleName", "")
      });
    }
  );
};
